module.exports = __webpack_public_path__ + "static/media/1.Portable Welding Machine.53ec1fcc.jpg";